import { render, staticRenderFns } from "./prepareGoods.vue?vue&type=template&id=a6660c6a&scoped=true&"
import script from "./prepareGoods.vue?vue&type=script&lang=js&"
export * from "./prepareGoods.vue?vue&type=script&lang=js&"
import style0 from "./prepareGoods.vue?vue&type=style&index=0&id=a6660c6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6660c6a",
  null
  
)

export default component.exports